<template>
    <div v-if="data.id">
        <Link :href="route('contacts.view', data.id)" class="text-blue-600">
          {{ data.first_name }} {{ data.last_name }}
        </Link>
    </div>

</template>


<script>

export default {
    name: 'ContactTableName',
    props: ['data'],
    data: () => ({
        showTooltip: false,
    }),
    computed: {
       
        

    },
}


</script>

<style scoped>
.error {
    @apply text-red-700 px-4 py-3;
}

</style>
